const Auth = ({
  width = 88,
  height = 88,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        fill="url(#paint0_linear_1050_34931)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        stroke="url(#paint1_linear_1050_34931)"
      />
      <g filter="url(#filter0_d_1050_34931)">
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect
          x="16.5"
          y="16.5"
          width="55"
          height="55"
          rx="27.5"
          stroke="#E2E4E9"
        />
        <path
          d="M46.1001 46.3638V48.5583C45.1498 48.2223 44.1327 48.1193 43.1343 48.2578C42.1359 48.3963 41.1853 48.7724 40.3623 49.3544C39.5393 49.9365 38.8681 50.7075 38.4048 51.6027C37.9416 52.4979 37.6999 53.4912 37.7001 54.4992L35.6001 54.4982C35.5998 53.216 35.893 51.9508 36.4572 50.7994C37.0215 49.6481 37.8418 48.6412 38.8553 47.8559C39.8689 47.0706 41.0487 46.5278 42.3045 46.2689C43.5603 46.0101 44.8586 46.0422 46.1001 46.3628V46.3638ZM44.0001 45.0492C40.5193 45.0492 37.7001 42.23 37.7001 38.7492C37.7001 35.2685 40.5193 32.4492 44.0001 32.4492C47.4808 32.4492 50.3001 35.2685 50.3001 38.7492C50.3001 42.23 47.4808 45.0492 44.0001 45.0492ZM44.0001 42.9492C46.3206 42.9492 48.2001 41.0697 48.2001 38.7492C48.2001 36.4287 46.3206 34.5492 44.0001 34.5492C41.6796 34.5492 39.8001 36.4287 39.8001 38.7492C39.8001 41.0697 41.6796 42.9492 44.0001 42.9492ZM50.9154 49.2492L48.9949 47.3298L50.4807 45.8441L54.9348 50.2992L50.4807 54.7544L48.9949 53.2686L50.9154 51.3492H47.1501V49.2492H50.9154Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1050_34931"
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1050_34931"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1050_34931"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1050_34931"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1050_34931"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Auth;
